import { SendEmailCodeResponse, VerifyCodeResponse } from './types';
import axiosInstance from '../../utils/axiosConfig';
import axios, {AxiosError} from "axios";

/**
 * Sendet eine Anfrage zum Versenden eines Login-Codes an die angegebene E-Mail-Adresse
 */
export const sendEmailCode = async (email: string): Promise<SendEmailCodeResponse> => {
  try {
    const response = await axiosInstance.post(
        '/send-login-code',
        {
          email: email
        }
    );
    if (response.status === 200) {
      return {
        success: true,
        // @todo anpassen, solle vom backend kommen
        expiresAt: Date.now() + 10 * 60 * 1000 // Code läuft in 10 Minuten ab
      };
    }
    return {
      success: false,
      errorCode: 'general_error'
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {  // Type Guard für TypeScript
      const axiosError = error as AxiosError<{message: string}>;
      if (axiosError.response) {
        return {
          success: false,
          errorCode: axiosError.response.data.message
        }
      }
    }
    return {
      success: false,
      errorCode: 'general_error'
    }
  }
};

/**
 * Überprüft den eingegebenen Code für die angegebene E-Mail-Adresse
 */
export const verifyCode = async (email: string, code: string): Promise<VerifyCodeResponse> => {
  try {

    const response = await axiosInstance.post('/login', {
      email: email,
      login_code: code,
    })

    return {
      success: true,
    };
  } catch (error) {
    console.error('Fehler bei der Code-Überprüfung:', error);
    if (axios.isAxiosError(error) && error.response) {
      const axiosError = error as AxiosError<{message: string}>;
      if (axiosError.response) {
        return {
          success: false,
          errorCode: axiosError.response.data.message
        }
      }
    }
    return {
      success: false,
      errorCode: 'NETWORK_ERROR'
    };
  }
};
